import { Component, ViewChild, Input, Output, EventEmitter} from '@angular/core';
import { BulkUploadInfluencer, InfluencerGroup, BulkUploadInfluencerDetail } from '../../../../../models/influencer-group';
import { TranslateService } from '@ngx-translate/core';
import { listOrderedPlatforms } from '../../../../app.constants';

@Component({
  selector: 'bulk-upload-influencer-modal',
  templateUrl: './bulk-upload-influencer-modal.component.html',
  styleUrls: ['./bulk-upload-influencer-modal.component.scss']
})
export class BulkUploadInfluencerModalComponent {

  static readonly MAX_INFLUENCER_NUMBER = 100;
  static readonly NUMBER_INFLUENCER_INFO_ITEM = 2;

  @Input() influencerGroup: InfluencerGroup;
  @Input() bulkUploadInfluencer: BulkUploadInfluencer = new BulkUploadInfluencer();

  @Output() beforeUploadBulkInfluencerEvent: EventEmitter<any> = new EventEmitter<any>();

  public bulkUploadInfluencerInputValue: string;

  public validationErrorMsg: string;

  constructor(private translate: TranslateService) { }

  uploadBulkInfluencer() {
    this.beforeUploadBulkInfluencerEvent.emit({
      data: this.bulkUploadInfluencer
    });
  }

  private checkInvalidInput(inputValue) {
    const invalidInputArr = [];
    inputValue.forEach(item => {
      const influencerItem = item.replace(/\s+/g, '').split(',');
      if (this.hasInvalidFormatOrPlatform(influencerItem)) {
        invalidInputArr.push(influencerItem);
      }
    });
    return invalidInputArr;
  }

  private hasInvalidFormatOrPlatform(influencerItem) {
    return influencerItem.length !== BulkUploadInfluencerModalComponent.NUMBER_INFLUENCER_INFO_ITEM || !influencerItem[0] || (influencerItem[0] && listOrderedPlatforms.filter(platformItem => platformItem.name.toLowerCase() === influencerItem[1].toLowerCase()).length === 0);
  }

  private mappingInputValue(bulkInfluencerData) {
    return bulkInfluencerData.map(item => {
      const splitedItem = item.replace(/\s+/g, '').split(',');
      const data: BulkUploadInfluencerDetail = new BulkUploadInfluencerDetail();
      data.handle = splitedItem[0];
      data.platform = splitedItem[1];
      return data;
    });
  }

  get disableContinueButton() {
    return !this.bulkUploadInfluencerInputValue || (this.bulkUploadInfluencerInputValue && this.validationErrorMsg);
  }

  focusoutEvent() {
    const bulkValue = this.bulkUploadInfluencerInputValue.split('\n');
    if (this.bulkUploadInfluencerInputValue && bulkValue.length > BulkUploadInfluencerModalComponent.MAX_INFLUENCER_NUMBER) {
      this.validationErrorMsg = this.translate.instant('bulk_upload_influencer.modal.exceed_max_influencer_number');
    } else if (this.bulkUploadInfluencerInputValue && this.checkInvalidInput(bulkValue).length > 0) {
      this.validationErrorMsg = this.translate.instant('bulk_upload_influencer.modal.invalid_input');
    } else {
      this.validationErrorMsg = null;
      this.bulkUploadInfluencer.influencers = this.mappingInputValue(bulkValue);
    }
  }

  inputEvent() {
    this.validationErrorMsg = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/bottombar-influencer-fragement/bulk-upload-influencer/bulk-upload-influencer-modal/bulk-upload-influencer-modal.component.ts